export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/howItWorks4.2b5bedb3.svg","height":380,"width":592,"blurWidth":0,"blurHeight":0};